'use client';

import { useEffect } from 'react';
import { useTranslation as useI18nTranslation } from 'react-i18next';

import { setDateLocaleResolver } from '@/shared/utils/dateFormat';

export function useTranslation(namespace: string = 'common') {
  const { t, i18n } = useI18nTranslation(namespace);

  useEffect(() => {
    setDateLocaleResolver(() => i18n.language);
  }, [i18n]);

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const getCurrentLanguage = () => i18n.language;

  const getAvailableLanguages = () => Object.keys(i18n.options.resources || {});

  return {
    t,
    changeLanguage,
    getCurrentLanguage,
    getAvailableLanguages,
    i18n,
  };
}
